<template>
  <div class="container-xxl">
    <footer class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
        <p class="col-md-4 mb-0 text-muted">© 2025 Designed by Mengqiao He</p>

        <span
           class="col-md-4 d-flex align-items-center justify-content-center mb-3 mb-md-0 me-md-auto link-dark text-decoration-none">
            <img class="bi me-2" src="@/assets/img/FPGDKG.png" alt="home" width="110" height="140" style="margin-top: 20px" >
            <!-- <img class="bi me-2" src="@/assets/img/huaxi.png" alt="home" width="200" height="118" > -->
        </span>

        <p class="col-md-4 mb-0 text-muted">Institutes for Systems Genetics Frontiers Science Center for Disease-related Molecular Network,West China Hospital, Sichuan University</p>



    </footer>

</div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>